import { Title, TextPartHighlight } from '@components/Sections/Sections.styled';

import { MainText } from './MainText';
import { TitlePenUnderline, IllustrationPens } from './Pens';
import {
  StyledContainer,
  TitlePartTop,
  TitlePartTopMobile,
  TitlePartBottom,
  TitlePartBottomNotMobile,
  TextBlock,
  Subtitle,
  Quote,
} from './SectionTwo.styled';

export const SectionTwo: React.FC = () => {
  return (
    <section>
      <StyledContainer>
        <Title>2. Acknowledgement and awareness</Title>

        <TitlePartTop role="presentation" aria-hidden>
          Acknowledge&shy;ment <TitlePartTopMobile>and</TitlePartTopMobile>
        </TitlePartTop>

        <TitlePartBottom role="presentation" aria-hidden>
          <TitlePartBottomNotMobile>and</TitlePartBottomNotMobile>{' '}
          <TextPartHighlight>
            awareness
            <TitlePenUnderline />
          </TextPartHighlight>
        </TitlePartBottom>

        <TextBlock className="text-block-second" aside={<Subtitle>Origins</Subtitle>} text={<MainText />} />

        <Quote
          quote="I feel that, from childhood, boys are included in the world of games. When a boy receives a game as a gift, his father doesn't scold him for playing it. Boys are one step ahead because of this culture. When a girl wants to play, her mother tells her it's not for her. For men it's something socially acceptable. A lot easier than for women. That's why fewer women compete… I see a huge cultural gap that is holding women back, and fewer of them end up competing."
          author="Female, professional player, 22 y.o."
        />

        <IllustrationPens />
      </StyledContainer>
    </section>
  );
};
